const messages = {
  it: {
    translations: {
      validation: {
        tooShort: "Troppo corto!",
        tooLong: "Troppo lungo!",
        required: "Campo obbligatorio",
        invalidEmail: "Email non valida",
        onlyNumbers: "Solo numeri",
      },
      signup: {
        title: "Registrati",
        heroText: "Crea un account per iniziare a gestire le tue interazioni con i clienti in modo semplice e affidabile.",
        subtitle: "Registrati per accedere alla piattaforma",
        toasts: {
          success: "Utente creato con successo! Effettua il login!",
          fail: "Errore nella creazione dell'utente. Controlla i dati inseriti.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Registrati",
          login: "Hai già un account? Accedi!",
        },
      },
      login: {
        title: "Accesso",
        heroText: "La piattaforma completa per il servizio clienti omnicanale. Gestisci team, contatti e ticket in un unico posto moderno e affidabile.",
        subtitle: "Accedi al tuo account per continuare",
        form: {
          email: "Email",
          password: "Password",
        },
        buttons: {
          submit: "Entra",
          register: "Non hai un account? Registrati!",
        },
      },
      auth: {
        toasts: {
          success: "Accesso effettuato con successo!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Ticket oggi: ",
          },
        },
        messages: {
          inAttendance: {
            title: "In gestione",
          },
          waiting: {
            title: "In attesa",
          },
          closed: {
            title: "Chiusi",
          },
        },
        metrics: {
          myOpenTickets: "I miei ticket aperti",
          unreadTickets: "Ticket non letti",
          staleTickets24h: "Ticket a rischio (>24h)",
          staleTickets24hHint: "Nessun aggiornamento nelle ultime 24 ore",
          closedToday: "Ticket chiusi oggi",
          messagesSentToday: "Messaggi inviati oggi",
          ticketsToday: "Nuovi ticket oggi",
          resolutionRateLast30Days: "Tasso di risoluzione (30 giorni)",
          mostContactedAccount: "Account più contattato",
          ticketsHandled: "ticket gestiti",
        },
      },
      connections: {
        title: "Connessioni",
        toasts: {
          deleted: "Connessione WhatsApp eliminata con successo!",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage: "Sei sicuro? L'operazione non può essere annullata.",
          disconnectTitle: "Disconnetti",
          disconnectMessage:
            "Sei sicuro? Dovrai rileggere il QR Code.",
        },
        buttons: {
          add: "Aggiungi WhatsApp",
          disconnect: "Disconnetti",
          tryAgain: "Riprova",
          qrcode: "QR CODE",
          newQr: "Nuovo QR CODE",
          connecting: "Connessione in corso",
        },
        toolTips: {
          disconnected: {
            title: "Avvio sessione WhatsApp fallito",
            content:
              "Assicurati che il tuo cellulare sia connesso a Internet e riprova, oppure richiedi un nuovo QR Code",
          },
          qrcode: {
            title: "In attesa della lettura del QR Code",
            content:
              "Clicca sul pulsante 'QR CODE' e scansiona il QR Code con il tuo cellulare per avviare la sessione",
          },
          connected: {
            title: "Connessione stabilita",
          },
          timeout: {
            title: "Connessione con il cellulare persa",
            content:
              "Assicurati che il tuo cellulare sia connesso a Internet e che WhatsApp sia aperto, oppure clicca su 'Disconnetti' per ottenere un nuovo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Stato",
          lastUpdate: "Ultimo aggiornamento",
          default: "Predefinito",
          actions: "Azioni",
          session: "Sessione",
        },
      },
      whatsappModal: {
        title: {
          add: "Aggiungi WhatsApp",
          edit: "Modifica WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Predefinito",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "WhatsApp salvato con successo.",
      },
      qrCode: {
        message: "Scansiona il QrCode per avviare la sessione",
      },
      contacts: {
        title: "Contatti",
        toasts: {
          deleted: "Contatto eliminato con successo!",
        },
        searchPlaceholder: "Cerca ...",
        confirmationModal: {
          deleteTitle: "Elimina",
          importTitlte: "Importa contatti",
          deleteMessage:
            "Sei sicuro di voler eliminare questo contatto? Tutti i ticket correlati andranno persi.",
          importMessage: "Vuoi importare tutti i contatti dal telefono?",
        },
        buttons: {
          import: "Importa contatti",
          add: "Aggiungi contatto",
        },
        filters: {
          allEpoLabel: "Tutti i contatti",
          onlyEpo: "Solo contatti EPO",
          notEpo: "Solo contatti non EPO",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Azioni",
        },
      },
      epoContacts: {
        title: "Contatti",
        searchPlaceholder: "Cerca ...",
        empty: "Nessun contatto trovato.",
        accordion: {
          unassigned: "Senza progetto",
          count: "{{count}} contatti",
        },
        filters: {
          allTipologie: "Tutte le tipologie",
          allCompanies: "Tutte le aziende",
          allProjects: "Tutti i progetti",
          sendByProjects: "Seleziona progetti",
          allPartner: "Tutti",
          onlyPartner: "Solo Partner Fidelizzati",
          notPartner: "Non Partner",
        },
        buttons: {
          add: "Nuovo contatto",
          sendVCards: "Invia VCard",
        },
        table: {
          name: "Nome",
          number: "Numero",
          company: "Azienda",
          projects: "Progetti",
          tipologia: "Tipologia",
          email: "Email",
          partner: "Stato",
          actions: "Azioni",
        },
        partnerStatus: {
          withNotes: "Partner Fidelizzato - Note presenti",
          missingNotes: "Partner Fidelizzato - Note mancanti",
          chipOk: "Partner",
          chipMissing: "Mancano note",
        },
        form: {
          title: {
            add: "Nuovo contatto",
            edit: "Modifica contatto",
          },
          photo: "Foto profilo (clicca per cambiare)",
          name: "Nome",
          lastName: "Cognome",
          number: "Numero WhatsApp",
          email: "Email",
          country: "Paese",
          city: "Città",
          address: "Indirizzo",
          zip: "CAP",
          jobTitle: "Posizione Lavorativa",
          company: "Azienda",
          projects: "Progetti",
          tipologia: "Tipologia",
          isPartnerFidelizzato: "Partner Fidelizzato",
          description: "Note post-call",
          linkedinUrl: "Profilo LinkedIn",
          internalReferent: "Referente interno (chi ha incontrato)",
          sendVCard: "Invia VCard al gruppo",
          buttons: {
            save: "Salva",
            cancel: "Annulla",
          },
          success: "Contatto salvato con successo.",
          errorDuplicate: "Esiste già un contatto con questo numero.",
        },
        confirmDelete: "Eliminare questo contatto?",
        deleteSuccess: "Contatto eliminato.",
        sendVCards: {
          success: "VCard inviate",
          confirm: "Inviare le VCard dei {{count}} contatti selezionati al numero TPM?",
          dialogTitle: "Invio VCard",
          selectedCount: "Selezionati: {{count}}",
          destinationLabel: "Destinazione",
          destinations: {
            manager: "Manager",
            scoutingGroup: "Gruppo scouting",
            managementGroup: "Gruppo management",
          },
          confirmButton: "Invia",
        },
      },
      contactModal: {
        title: {
          add: "Aggiungi contatto",
          edit: "Modifica contatto",
        },
        hubspotFlow: "Sincronizzazione HubSpot",
        form: {
          mainInfo: "Dati del contatto",
          extraInfo: "Informazioni aggiuntive",
          name: "Nome",
          lastName: "Cognome",
          number: "Numero WhatsApp",
          email: "Email",
          description: "Descrizione / Note",
          descriptionPlaceholder: "Inserisci una descrizione o nota per questo contatto...",
          age: "Età",
          country: "Paese",
          extraName: "Nome campo",
          extraValue: "Valore",
          hubspotSection: "Dati HubSpot",
          leadStatus: "Stato Lead",
          tipologia: "Tipologia",
          cluster: "Connessione (Cluster)",
          owner: "Operatore",
        },
        buttons: {
          addExtraInfo: "Aggiungi informazione",
          okAdd: "Aggiungi",
          okEdit: "Salva",
          saveToHubSpot: "Salva e sincronizza HubSpot",
          cancel: "Annulla",
        },
        success: "Contatto salvato con successo.",
        hubspotSuccess: "Contatto sincronizzato su HubSpot con successo.",
      },
      quickAnswersModal: {
        title: {
          add: "Aggiungi risposta rapida",
          edit: "Modifica risposta rapida",
        },
        form: {
          shortcut: "Scorciatoia",
          message: "Risposta rapida",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Risposta rapida salvata con successo.",
      },
      queueModal: {
        title: {
          add: "Aggiungi coda",
          edit: "Modifica coda",
        },
        form: {
          name: "Nome",
          color: "Colore",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        toasts: {
          success: "Coda salvata con successo!",
        },
      },
      userModal: {
        title: {
          add: "Aggiungi utente",
          edit: "Modifica utente",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Password",
          profile: "Profilo",
          whatsapp: "Connessione predefinita",
        },
        buttons: {
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Utente salvato con successo.",
      },
      chat: {
        noTicketMessage: "Seleziona un ticket per iniziare a chattare.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuovo",
        },
        whatsappFilter: {
          all: "Tutte le connessioni",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Code",
      },
      tickets: {
        toasts: {
          deleted: "Il ticket su cui ti trovavi è stato eliminato.",
          ticketDeleted: "Ticket eliminato con successo.",
        },
        notification: {
          message: "Messaggio da",
        },
        tabs: {
          open: { title: "Posta in arrivo" },
          closed: { title: "Risolti" },
          search: { title: "Cerca" },
        },
        search: {
          placeholder: "Cerca ticket e messaggi.",
        },
        buttons: {
          showAll: "Tutti",
        },
      },
      transferTicketModal: {
        title: "Trasferisci ticket",
        fieldLabel: "Digita per cercare utenti",
        fieldQueueLabel: "Trasferisci alla coda",
        fieldConnectionLabel: "Trasferisci alla connessione",
        fieldQueuePlaceholder: "Seleziona una coda",
        fieldConnectionPlaceholder: "Seleziona una connessione",
        noOptions: "Nessun utente trovato con questo nome",
        buttons: {
          ok: "Trasferisci",
          cancel: "Annulla",
        },
      },
      ticketsList: {
        pendingHeader: "Coda",
        assignedHeader: "In gestione",
        noTicketsTitle: "Niente qui!",
        noTicketsMessage:
          "Nessun ticket trovato con questo stato o termine di ricerca.",
        connectionTitle: "Connessione attualmente in uso.",
        buttons: {
          accept: "Accetta",
        },
      },
      newTicketModal: {
        title: "Crea ticket",
        fieldLabel: "Digita per cercare un contatto",
        add: "Aggiungi",
        buttons: {
          ok: "Salva",
          cancel: "Annulla",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connessioni",
          tickets: "Ticket",
          contacts: "Contatti",
          projects: "Progetti",
          epoContacts: "Contatti",
          quickAnswers: "Risposte rapide",
          queues: "Code",
          administration: "Amministrazione",
          users: "Utenti",
          settings: "Impostazioni",
        },
        appBar: {
          user: {
            profile: "Profilo",
            logout: "Esci",
          },
        },
      },
      projects: {
        title: "Progetti",
        searchPlaceholder: "Cerca ...",
        filters: {
          allCompanies: "Tutte le aziende",
        },
        buttons: {
          add: "Nuovo progetto",
        },
        table: {
          name: "Nome",
          company: "Azienda",
          contacts: "Contatti",
          description: "Descrizione",
          actions: "Azioni",
        },
        form: {
          title: {
            add: "Nuovo progetto",
            edit: "Modifica progetto",
          },
          name: "Nome",
          company: "Azienda",
          description: "Descrizione",
          buttons: {
            save: "Salva",
            cancel: "Annulla",
          },
          success: "Progetto salvato con successo.",
        },
        confirmDelete: "Eliminare questo progetto?",
        deleteSuccess: "Progetto eliminato.",
      },
      epoDashboard: {
        title: "Dashboard",
        welcome: "Benvenuto, {name}!",
        subtitle: "Gestisci i tuoi contatti e monitora lo stato dei partner.",
        stats: {
          total: "Contatti totali",
          partner: "Partner Fidelizzati",
          partnerWithNotes: "Partner con note",
        },
        buttons: {
          contacts: "Vai ai contatti",
          addContact: "Nuovo contatto",
        },
      },
      notifications: {
        noTickets: "Nessuna notifica.",
      },
      queues: {
        title: "Code",
        table: {
          name: "Nome",
          color: "Colore",
          greeting: "Messaggio di benvenuto",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi coda",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Sei sicuro? L'operazione non può essere annullata! I ticket in questa coda continueranno ad esistere, ma non avranno nessuna coda assegnata.",
        },
      },
      queueSelect: {
        inputLabel: "Code",
      },
      quickAnswers: {
        title: "Risposte rapide",
        table: {
          shortcut: "Scorciatoia",
          message: "Risposta rapida",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi risposta rapida",
        },
        toasts: {
          deleted: "Risposta rapida eliminata con successo.",
        },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Sei sicuro di voler eliminare questa risposta rapida: ",
          deleteMessage: "Questa azione non può essere annullata.",
        },
      },
      users: {
        title: "Utenti",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Profilo",
          whatsapp: "Connessione predefinita",
          actions: "Azioni",
        },
        buttons: {
          add: "Aggiungi utente",
        },
        toasts: {
          deleted: "Utente eliminato con successo.",
        },
        confirmationModal: {
          deleteTitle: "Elimina",
          deleteMessage:
            "Tutti i dati dell'utente andranno persi. I ticket aperti dell'utente verranno spostati in coda.",
        },
      },
      settings: {
        success: "Impostazioni salvate con successo.",
        title: "Impostazioni",
        settings: {
          userCreation: {
            name: "Creazione utente",
            options: {
              enabled: "Abilitato",
              disabled: "Disabilitato",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assegnato a:",
          buttons: {
            return: "In attesa",
            resolve: "Risolvi",
            reopen: "Riapri",
            accept: "Accetta",
          },
        },
      },
      messagesInput: {
        placeholderOpen:
          "Scrivi un messaggio o premi ''/'' per usare le risposte rapide registrate",
        placeholderClosed:
          "Riapri o accetta questo ticket per inviare un messaggio.",
      },
      contactDrawer: {
        header: "Dettagli contatto",
        buttons: {
          edit: "Modifica contatto",
          saveToHubSpot: "Salva su HubSpot",
          pullFromHubSpot: "Aggiorna da HubSpot",
        },
        pullHubSpot: {
          success: "Contatto aggiornato da HubSpot",
          noData: "Nessun dato nuovo trovato su HubSpot",
          error: "Errore durante il recupero da HubSpot",
        },
        extraInfo: "Altre informazioni",
      },
      ticketOptionsMenu: {
        delete: "Elimina",
        transfer: "Trasferisci",
        confirmationModal: {
          title: "Elimina ticket #",
          titleFrom: "dal contatto ",
          message:
            "Attenzione! Tutti i messaggi relativi al ticket andranno persi.",
        },
        buttons: {
          delete: "Elimina",
          cancel: "Annulla",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Annulla",
        },
      },
      messageOptionsMenu: {
        delete: "Elimina",
        reply: "Rispondi",
        saveDescriptionToHubSpot: "Salva la descrizione su HubSpot",
        hubspotDescriptionSaved: "Descrizione salvata su HubSpot.",
        confirmationModal: {
          title: "Eliminare il messaggio?",
          message: "Questa azione non può essere annullata.",
        },
      },
      general: {
        error: "Si è verificato un errore!",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Deve esserci almeno una connessione WhatsApp predefinita.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nessun WhatsApp predefinito trovato. Controlla la pagina delle connessioni.",
        ERR_WAPP_NOT_INITIALIZED:
          "Questa sessione WhatsApp non è inizializzata. Controlla la pagina delle connessioni.",
        ERR_WAPP_CHECK_CONTACT:
          "Impossibile verificare il contatto WhatsApp. Controlla la pagina delle connessioni.",
        ERR_WAPP_INVALID_CONTACT: "Questo non è un numero WhatsApp valido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Impossibile scaricare il media da WhatsApp. Controlla la pagina delle connessioni.",
        ERR_INVALID_CREDENTIALS: "Errore di autenticazione. Riprova.",
        ERR_SENDING_WAPP_MSG:
          "Errore nell'invio del messaggio WhatsApp. Controlla la pagina delle connessioni.",
        ERR_DELETE_WAPP_MSG: "Impossibile eliminare il messaggio da WhatsApp.",
        ERR_OTHER_OPEN_TICKET:
          "Esiste già un ticket aperto per questo contatto.",
        ERR_SESSION_EXPIRED: "Sessione scaduta. Effettua nuovamente il login.",
        ERR_USER_CREATION_DISABLED:
          "La creazione di utenti è stata disabilitata dall'amministratore.",
        ERR_NO_PERMISSION:
          "Non hai i permessi per accedere a questa risorsa.",
        ERR_EMAIL_OR_NUMBER_REQUIRED:
          "Inserire almeno un numero WhatsApp o un'email.",
        ERR_DUPLICATED_CONTACT:
          "Esiste già un contatto con questo numero.",
        ERR_CONTACT_NUMBER_MISSING_PREFIX:
          "Includi il prefisso internazionale senza + (es. IT: 39331…, UK: 44791…, US: 1212…).",
        ERR_NO_SETTING_FOUND: "Nessuna impostazione trovata con questo ID.",
        ERR_NO_CONTACT_FOUND: "Nessun contatto trovato con questo ID.",
        ERR_NO_TICKET_FOUND: "Nessun ticket trovato con questo ID.",
        ERR_NO_USER_FOUND: "Nessun utente trovato con questo ID.",
        ERR_NO_WAPP_FOUND: "Nessun WhatsApp trovato con questo ID.",
        ERR_CREATING_MESSAGE:
          "Errore durante la creazione del messaggio nel database.",
        ERR_CREATING_TICKET:
          "Errore durante la creazione del ticket nel database.",
        ERR_FETCH_WAPP_MSG:
          "Errore nel recupero del messaggio da WhatsApp, potrebbe essere troppo vecchio.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Questo colore è già in uso, sceglierne un altro.",
        ERR_WAPP_GREETING_REQUIRED:
          "Il messaggio di benvenuto è obbligatorio se è presente più di una coda.",
      },
    },
  },
};

export { messages };
